<template>
    <validation class="form-group-feedback form-group-feedback-left" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" name="email">
        <input type="text" :disabled='isLoading' v-model.trim="email" class="form-control"  v-bind:class="[ (v.$error || verr[0]) ? 'border-danger' : '' ]" placeholder="Email">
        <div class="form-control-feedback">
            <i class="icon-mention text-muted"></i>
        </div>
        <div v-if="verr[0]" class="form-text text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
    mixins: [singleErrorExtractorMixin],
    props: {
        value: {
            type: String,
            default: ""
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        }
    },
    computed: {
        email: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
    }
}
};
</script>